<template>
  <el-form class="apply-form section-container" ref="apply-form" :class="{'dark':skinType}"
  model="form" label-width="80px">
    <el-form-item label="申请标题" :class="{'light-label':skinType}" required>
      <el-input v-model="form.Title" maxlength="30" show-word-limit
      placeholder="请填写标题"></el-input>
    </el-form-item>
    <el-form-item label="计划时间" :class="{'light-label':skinType}"
     style="text-align: left" required>
        <el-date-picker
          type="daterange"
          placeholder="选择日期"
          v-model="form.selectPeriod"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
    </el-form-item>
    <el-form-item label="所属项目" :class="{'light-label':skinType}"
     style="text-align: left" required>
      <el-select v-model="form.ProjectIDstr" placeholder="请选择">
        <el-option
          v-for="project in projectList"
          :key="project.IdStr"
          :label="project.ModelName"
          :value="project.IdStr"
        >
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="联系电话" :class="{'light-label':skinType}">
      <el-input
        v-model="form.Contact"
        maxlength="15"
        placeholder="请输入联系电话"
        type="tel"
      ></el-input>
    </el-form-item>
    <el-form-item label="类别" :class="{'light-label':skinType}"
     style="text-align: left" required>
      <el-radio-group v-model="ApplyClass" size="mini">
        <el-radio-button label="试验" value="试验"></el-radio-button>
        <el-radio-button label="抢修" value="抢修"></el-radio-button>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="类型" :class="{'light-label':skinType}"
      style="text-align: left" >
      <el-select v-model="form.ApplySubClass" placeholder="请选择">
        <el-option
          v-for="item in typeList"
          :key="item.id"
          :label="item.text"
          :value="item.id"
        >
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="申请描述" :class="{'light-label':skinType}"
     required>
      <el-input
        type="textarea"
        maxlength="200"
        show-word-limit
        v-model="form.ApplyInfo"
        :rows="4"
      ></el-input>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" size="mini" @click="onSubmit">提交</el-button>
      <el-button size="mini">取消</el-button>
    </el-form-item>
  </el-form>
</template>
<script>
import { submitWork } from '@/api/maintain/maintain';
import { formatDate } from '@/utils/utils';
import { getDataDictionary } from '@/api/utils/utils';

export default {
  name: 'apply',
  data() {
    return {
      ApplyClass: '试验',
      form: {
        ApplyClass: '试验',
        selectPeriod: [formatDate(new Date(Date.now() + 24 * 60 * 60 * 1000), 'yyyy-MM-dd'),
          formatDate(new Date(Date.now() + 24 * 60 * 60 * 1000), 'yyyy-MM-dd')],
      },
      typeList: [],
    };
  },
  created() {
    this.requestProjectList();
    this.requestTypeList();
  },
  watch: {
    ApplyClass: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.requestTypeList();
        }
      },
    },
    projectList() {
      this.initialData();
    },
  },
  computed: {
    projectList() {
      return this.$store.getters.projectList;
    },
    skinType() {
      return this.$store.getters.skinType;
    },
  },
  methods: {
    initialData() {
      const [firstProject] = this.projectList;
      this.$set(this.form, 'ProjectIDstr', firstProject.IdStr);
    },
    onSubmit() {
      const [PlanBeginDate, PlanEndDate] = this.form.selectPeriod;
      const ProjectName = this.getSelectProjectName(this.projectList, this.form.ProjectIDstr);
      const data = {
        ...this.form,
        PlanBeginDate,
        PlanEndDate,
        ProjectName,
        ApplyClass: this.ApplyClass,
        WIDstr: '',
      };
      delete data.selectPeriod;
      const formData = this.getFormData(data);
      submitWork(formData).then((res) => {
        console.log(res);
        this.$message({
          message: '提交成功！',
          type: 'success',
        });
        this.resetFormData();
      });
    },
    resetFormData() {
      this.form = {
        ApplyClass: '试验',
        selectPeriod: [formatDate(new Date(Date.now() + 24 * 60 * 60 * 1000), 'yyyy-MM-dd'),
          formatDate(new Date(Date.now() + 24 * 60 * 60 * 1000), 'yyyy-MM-dd')],
      };
    },
    getFormData(data) {
      const keys = Object.keys(data);
      const formData = new FormData(this.$refs['apply-form'].$el);
      for (let i = 0; i < keys.length; i += 1) {
        const key = keys[i];
        formData.append(key, data[key]);
      }
      return formData;
    },
    getSelectProjectName(list, id) {
      const project = list.find((item) => item.IdStr === id);
      return project.ModelName;
    },
    // 获取类型列表
    requestTypeList() {
      if (!this.ApplyClass) {
        return;
      }
      getDataDictionary({
        EnCode: this.ApplyClass === '试验' ? 'shiyan' : 'qiangxiu',
      }).then((res) => {
        console.log('requestTypeList', res);
        this.typeList = res.list || res;
        this.$set(this.form, 'ApplySubClass', this.typeList[0].id);
      });
    },
    requestProjectList() {
      if (this.projectList !== null) {
        this.initialData();
        return;
      }
      this.$store.dispatch('projects/projectList', { level: 1 });
    },
  },
};
</script>
<style scoped>
.apply-form {
  padding: 5rem 25%;
}
</style>
